import {
    createRouter,
    // createWebHashHistory
    createWebHistory,
} from "vue-router";
import Home from "../views/Home.vue";
import { getPcUrl } from "../assets/config.js";
import util from "../assets/util";

const lang = util.language("text");

const title = {
    zh: {
        home: "Wellcee | 唯心所寓: 让世界上每个有可能的地方都变成家！",
        lifestyle: "Wellcee· Lifestyle | 唯心所寓-感受最多元的生活&社交方式！",
        community: "Wellcee· 社区 | 唯心所寓-感受最多元的生活&社交方式！",
        house: "Wellcee 北京、上海、深圳、香港、广州、杭州、成都个人租房信息",
    },
    en: {
        home: "Wellcee: New ways of living & sharing life.",
        lifestyle: "Wellcee· Lifestyle｜New ways of living & sharing life.",
        community: "Wellcee· Community｜New ways of living & sharing life.",
        house:
            "Beijing, Shanghai, Shenzhen, Hong Kong, Guangzhou, Hangzhou, Chengdu personal rental information.",
    },
    tw: {
        home: "Wellcee | 唯心所寓: 讓世界上每個有可能的地方都變成家！",
        lifestyle: "Wellcee· Lifestyle | 唯心所寓-感受最多元的生活&社交方式！",
        community: "Wellcee· Community｜唯心所寓-感受最多元的生活&社交方式！",
        house: "Wellcee 北京、上海、深圳、香港、广州、杭州、成都个人租房信息",
    },
};

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            title: title[lang].home,
            keepAlive: true,
        },
    },
    {
        path: "/community/:id",
        name: "CommunityDetails",
        component: () => import("../views/community/detail.vue"),
        meta: {
            title: "社区",
        },
    },
    {
        path: "/community/tag",
        name: "communityTagList",
        component: () => import("../views/community/tag.vue"),
        meta: {
            // keepAlive: true,
            title: title[lang].community,
        },
    },
    {
        path: "/lifestyle/:id",
        name: "LifestyleDetails",
        component: () => import("../views/lifestyle/detail.vue"),
        meta: {
            title: "Lifestyle",
        },
    },
    {
        path: "/lifestyle",
        name: "LifestyleList",
        component: () => import("../views/lifestyle/list.vue"),
        meta: {
            // keepAlive: true,
            title: title[lang].lifestyle,
        },
    },
    {
        path: "/lifestyle/tag",
        name: "LifestyleTagList",
        component: () => import("../views/lifestyle/tag.vue"),
        meta: {
            // keepAlive: true,
            title: title[lang].lifestyle,
        },
    },
    {
        path: "/user/:id",
        name: "UserDetails",
        component: () => import("../views/user/detail.vue"),
        meta: {
            title: "Details",
        },
    },
    {
        path: "/rent-apartment/:id",
        name: "HousingDetails",
        component: () => import("../views/house/detail.vue"),
        meta: {
            title: "Housing Details",
        },
    },
    {
        path: "/rent-apartment/:city/list",
        name: "HousingList",
        component: () => import("../views/house/list.vue"),
        meta: {
            // keepAlive: true,
            title: title[lang].house,
        },
    },
    {
        path: "/download",
        name: "Download",
        component: () => import("../views/download/index.vue"),
        meta: {
            title: "Wellcee App",
        },
    },
    {
        path: "/d",
        name: "download",
        component: () => import("../views/download/index.vue"),
        meta: {
            title: "Wellcee App",
        },
    },
    {
        path: "/business",
        name: "Business",
        component: () => import("../views/business/index.vue"),
        meta: {
            title: "商务合作",
        },
    },
    {
        path: "/help/no_auth_code",
        component: () => import("../views/help/no_auth_code.vue"),
        meta: {
            title: "收不到验证码",
        },
    },
    {
        path: "/help/phone_stop",
        component: () => import("../views/help/phone_stop.vue"),
        meta: {
            title: "手机号停机",
        },
    },
    {
        path: "/help/coupon_rule",
        component: () => import("../views/help/coupon_rule.vue"),
        meta: {
            title: "优惠券规则",
        },
    },
    {
        path: "/help/privacy_policy",
        component: () => import("../views/help/privacy_policy.vue"),
        meta: {
            title: "Wellcee唯心所寓房源推广服务协议",
        },
    },
    {
        path: "/help/landlord_academy_rule",
        component: () => import("../views/help/landlord_academy_rule.vue"),
        meta: {
            title: "规则说明",
        },
    },
    {
        path: "/sign/contract",
        component: () => import("../views/sign/contract.vue"),
        meta: {
            title: "合同",
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    // 判断是否在移动端
    const isMobile =
        navigator.userAgent.toLocaleLowerCase().indexOf("mobile") > -1;
    if (!isMobile) {
        let url = getPcUrl();
        switch (to.name) {
            case "Home":
                location.href = url;
                break;
            case "LifestyleList":
                location.href = url + "lifestyle";
                break;
            case "LifestyleDetails":
                let searchParams = new URLSearchParams(location.search);
                searchParams.set("id", to.params.id);
                let search = searchParams.toString();
                location.href = url + `lifestyle/detail?${search}`;
                break;
            case "UserDetails":
                location.href = url + `index/user/personal?id=${to.params.id}`;
                break;
            case "HousingDetails":
                location.href =
                    url + `rent-apartment/${to.params.id}${location.search}`;
                break;
            case "HousingList":
                location.href =
                    url +
                    `rent-apartment/${to.params.city}/list?cityId=${to.query.cityId}`;
                break;
            case "Download":
                location.href = url;
                break;
            case "download":
                location.href = url;
                break;
            default:
                next();
                break;
        }
    } else {
        next();
    }
});

export default router;
